import React, { useState } from "react";
import brushes from "../assets/contactimage/brushes.png";
import { toast } from "react-hot-toast";
import { motion } from "framer-motion";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { TailSpin } from "react-loader-spinner";

const ContactMe = () => {
  const [isLoading, setIsLoading] = useState(false);

  const spinner = () => (
    <TailSpin
      visible={true}
      height="30"
      width="30"
      color="#282c34"
      ariaLabel="tail-spin-loading"
      radius="1"
      wrapperStyle={{}}
      wrapperClass=""
    />
  );
  return (
    <motion.div
      className="flex flex-col lg:flex-row justify-around items-center p-10 my-10"
      initial={{
        opacity: 0,
      }}
      whileInView={{
        opacity: 1,
      }}
      transition={{
        duration: 1,
      }}
      viewport={{
        once: true,
      }}
    >
      <div className="mb-6 lg:mb-0 md:mr-10">
        <LazyLoadImage
          src={brushes}
          style={{ width: 317, height: 500 }}
          alt={"image"}
          loading="lazy"
          effect="blur"
        />
      </div>

      <div>
        <p className="font-normal font-sans text-md mb-5 lg:mr-8 text-center md:text-start">
          Feel free to reach out to me through this form or on my{" "}
          <a
            className=" text-rose-300"
            href="https://www.facebook.com/HairandMakeupbyMaggieDeoduco"
            target={"_blank"}
            rel="noreferrer"
          >
            Facebook Page.
          </a>{" "}
        </p>
        <form
          className="flex flex-col"
          onSubmit={async (event) => {
            event.preventDefault();
            setIsLoading(true);
            const formData = new FormData(event.target);

            const senderEmail = formData.get("senderEmail");
            const message = formData.get("message");

            try {
              const response = await fetch(
                process.env.REACT_APP_API_ENV === "PROD"
                  ? process.env.REACT_APP_PROD_API_URL
                  : process.env.REACT_APP_DEV_API_URL,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    senderEmail,
                    message,
                  }),
                }
              );

              if (response.ok) {
                toast.success("Email sent successfully!");
              } else {
                toast.error("Failed to send email.");
              }
            } catch (error) {
              console.error("Failed to send email:", error);
              toast.error("Failed to send email. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
        >
          <input
            name="senderEmail"
            type={"email"}
            placeholder="Your Email *"
            required
            className="h-12 px-4 border-t border-l border-r border-black"
          />
          <textarea
            name="message"
            placeholder="Your Message *"
            required
            className="h-48 p-4 border border-black"
          />
          <div className="mx-auto md:mx-0">
            <button
              type="submit"
              className="group flex items-center justify-center gap-2 h-[3rem] w-[15rem] text-black border border-black mt-4 py-6"
              disabled={isLoading}
            >
              {isLoading ? <>{spinner()}</> : <span>Send Message</span>}
            </button>
          </div>
        </form>
      </div>
    </motion.div>
  );
};

export default ContactMe;
